/**
 * Vuex store for products
 */
import { Commit } from "vuex";
import ProductLink from "@/models/ProductLink";
import Asset from "@/models/Asset";

type ProductLinkState = {
    productLink: ProductLink;
};

const initialState = {
    productLink: {
        filesId: null,
        companyId: null,
        promotionalText: "",
        productName: "",
        descriptionLine1: "",
        descriptionLine2: "",
        price: "",
        additionalCopy: "",
        fileUrl: "",
        fileRemoteObjectId: null,
        dateModified: null,
        dateCreated: null,
        status: false,
        productUrl: "",
        disabled: false,
    },
};

export default {
  state: initialState,

  getters: {
    productLink(state: ProductLinkState) {
      return state.productLink;
    },
  },

  mutations: {
    setProductLink(state: ProductLinkState, productLink: ProductLink) {
      state.productLink = productLink;
    },
  },

  actions: {
   
  },
};
